const CHANNELS = [
  { icon: "ri-send-plane-line", label: "匿名文字爆料" },
  { icon: "ri-image-2-line", label: "截图 / 单据" },
  { icon: "ri-vidicon-line", label: "视频 / 录音" },
  { icon: "ri-links-line", label: "长期合作对接" },
];

export default function CTA() {
  return (
    <section id="submit" className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Close%20up%20of%20an%20anonymous%20hand%20dropping%20a%20sealed%20envelope%20into%20a%20glowing%20warm%20orange%20drop%20slot%2C%20vermillion%20and%20amber%20bokeh%20background%2C%20cinematic%20moody%20lighting%2C%20editorial%20photography%2C%20sense%20of%20safe%20submission&width=1600&height=800&seq=cta-gossip-2026&orientation=landscape"
        alt="吃瓜投稿合作入口匿名投递"
        title="吃瓜投稿匿名投递合作"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/75 to-background-950/85"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-flex items-center gap-1.5 text-secondary-300 text-xs font-medium tracking-wide mb-5 rounded-full bg-white/10 backdrop-blur px-4 py-1.5 border border-white/20">
          <i className="ri-shield-user-line"></i> 匿名 · 脱敏 · 人工复核 · 依法处理
        </span>
        <h2 className="font-heading text-background-50 text-3xl md:text-5xl font-black leading-tight">
          有料、有证、有故事，
          <br className="hidden md:block" />
          就把它递到能见光的地方
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-background-200 text-base md:text-lg leading-relaxed">
          无论你是想匿名爆料曝光，还是想长期提供内幕线索、洽谈合作——都从一个入口开始。
          材料越实，走得越远；身份越隐，越无后顾之忧。
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="#submit"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 hover:bg-primary-400 text-background-50 text-base px-8 py-4 font-medium transition-colors w-full sm:w-auto justify-center whitespace-nowrap"
          >
            <i className="ri-lock-2-line text-lg"></i>
            匿名投递线索
          </a>
          <a
            href="#submit"
            className="inline-flex items-center gap-2 rounded-full bg-background-50/10 hover:bg-background-50/20 backdrop-blur text-background-50 text-base px-8 py-4 font-medium border border-white/30 transition-colors w-full sm:w-auto justify-center whitespace-nowrap"
          >
            <i className="ri-service-line text-lg"></i>
            洽谈合作入口
          </a>
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-2 md:gap-3 max-w-2xl mx-auto">
          {CHANNELS.map((c) => (
            <div
              key={c.label}
              className="flex items-center justify-center gap-2 rounded-lg bg-white/10 backdrop-blur px-2 py-3 border border-white/15 text-background-100 text-xs md:text-sm"
            >
              <i className={`${c.icon} text-secondary-300 text-base`}></i>
              <span>{c.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}